import React from "react"
import { ContentCopy } from "@mui/icons-material"
import { IconButton } from "@mui/material"

import CustomTextarea from "./CustomTextarea"
import { useTranslation } from "react-i18next"
import { useSnackbar } from "src/providers/SnackbarProvider"
import { useResponsive } from "src/utils/useResponsive"

interface TranslationResultProps {
  value: string
  disabled?: boolean
  onModify?: (text: string) => void
  onCopy?: () => void
  rows?: number
}

const TranslationResult = ({ value, disabled, onCopy, onModify, rows }: TranslationResultProps) => {
  const { snackbarShowMessage } = useSnackbar()
  const { t } = useTranslation("common")
  const { isMobile } = useResponsive()
  const onCopyClick = () => {
    navigator.clipboard.writeText(value)
    onAssetCopy()
  }

  const onAssetCopy = () => {
    snackbarShowMessage(t("translate.copy"), "info")
    onCopy?.()
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "c") {
      onAssetCopy()
    }
  }

  return (
    <CustomTextarea
      rows={rows}
      value={value}
      disabled={disabled}
      onUpdate={onModify}
      onKeyDown={handleKeyDown}
      endBottomAdornment={
        !!value && (
          <IconButton
            onClick={onCopyClick}
          >
            <ContentCopy fontSize="large" />
          </IconButton>
        )
      }
    />
  )
}
export default TranslationResult
